import Vue from 'vue'
import Router from 'vue-router'
import Login from "../components/Login";

// push
const VueRouterPush = Router.prototype.push
Router.prototype.push = function push(to) {
    return VueRouterPush.call(this, to).catch(err => err)
}
// replace
const VueRouterReplace = Router.prototype.replace
Router.prototype.replace = function replace(to) {
    return VueRouterReplace.call(this, to).catch(err => err)
}
Vue.use(Router)

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        /*{
            path: '/',
            component: () => import('../components/Home'),
        },*/
        {
            path: '/home',
            component: () => import(/* webpackChunkName: "zhanhui" */ '../components/NoHome'),
        },
        {
            path: '/',
            redirect: '/home',
        },
        {
            path: '/login',
            component: Login,
        },
       /* {
            path: '/',
            redirect: '/zhanhui/home',
        },*/
        {
            path: '/zhanhui',
            redirect: '/zhanhui/home',
        },
        {
            path: '/zhanhui/home',
            component: () => import(/* webpackChunkName: "zhanhui" */ '../components/ZhanhuiHome'),
        },
        {
            path: '/service',
            redirect: '/service/list',
        },
        {
            path: '/service/home',
            component: () => import(/* webpackChunkName: "zhanhui" */ '../components/ServiceHome'),
        },
        {
            path: '/service/list',
            component: () => import(/* webpackChunkName: "zhanhui" */ '../components/ServiceList'),
        },
        {
            path: '/zhanhui/industry-home',
            component: () => import(/* webpackChunkName: "zhanhui" */ '../components/ZhanhuiIndustryHome'),
        },
        {
            path: '/zhanhui/list',
            component: () => import(/* webpackChunkName: "zhanhui" */ '../components/ZhanhuiList'),
        },
        {
            path: '/zhanhui/abroad-list',
            component: () => import(/* webpackChunkName: "zhanhui" */ '../components/AbroadZhanhuiList'),
        },
        {
            path: '/zhanhui/details',
            component: () => import(/* webpackChunkName: "zhanhui" */ '../components/ZhanhuiDetails'),
        },
        {
            path: '/zhanhui/abroad-details',
            component: () => import(/* webpackChunkName: "zhanhui" */ '../components/AbroadZhanhuiDetails'),
        },
        {
            path: '/huiyi/list',
            component: () => import(/* webpackChunkName: "huiyi" */ '../components/HuiyiList'),
        },
        {
            path: '/huiyi/abroad-list',
            component: () => import(/* webpackChunkName: "huiyi" */ '../components/AbroadHuiyiList'),
        },
        {
            path: '/huiyi/details',
            component: () => import(/* webpackChunkName: "huiyi" */ '../components/HuiyiDetails'),
        },
        {
            path: '/huiyi/abroad-details',
            component: () => import(/* webpackChunkName: "huiyi" */ '../components/AbroadHuiyiDetails'),
        },
        {
            path: '/hxe-changguan/list',
            component: () => import(/* webpackChunkName: "hxe-changguan" */ '../components/HxeChangguanList'),
        },
        {
            path: '/hxe-changguan/details',
            component: () => import(/* webpackChunkName: "hxe-changguan" */ '../components/HxeChangguanDetails'),
        },
        {
            path: '/changguan/abroadDetails',
            component: () => import(/* webpackChunkName: "hxe-changguan" */ '../components/AbroadChangguanDetails'),
        },
        {
            path: '/changguan',
            redirect: '/changguan/home',
        },
        {
            path: '/changguan/home',
            component: () => import(/* webpackChunkName: "changguan" */ '../components/ChangguanHome'),
        },
        {
            path: '/changguan/list',
            component: () => import(/* webpackChunkName: "changguan" */ '../components/ChangguanList'),
        },
        {
            path: '/abroadchangguan/list',
            component: () => import(/* webpackChunkName: "changguan" */ '../components/AbroadChangguanList'),
        },
        {
            path: '/changguan/details',
            component: () => import(/* webpackChunkName: "changguan" */ '../components/ChangguanDetails'),
        },
        {
            path: '/company',
            redirect: '/company/home',
        },
        {
            path: '/company/home',
            component: () => import(/* webpackChunkName: "company" */ '../components/CompanyHome'),
        },
        {
            path: '/company/list',
            component: () => import(/* webpackChunkName: "company" */ '../components/CompanyList'),
        },
        {
            path: '/service/list',
            component: () => import(/* webpackChunkName: "company" */ '../components/CompanyList'),
        },
        {
            path: '/company/details',
            component: () => import(/* webpackChunkName: "company" */ '../components/CompanyDetails'),
        },
        {
            path: '/company/thirdDetails',
            component: () => import(/* webpackChunkName: "company" */ '../components/ThirdCompanyDetails'),
        },
        {
            path: '/ztb/list',
            component: () => import(/* webpackChunkName: "ztb" */ '../components/ZtbList'),
        },
        {
            path: '/zcfg',
            redirect: '/zcfg/home',
        },
        {
            path: '/zcfg/home',
            component: () => import(/* webpackChunkName: "zcfg" */ '../components/ZcfgHome'),
        },
        {
            path: '/zcfg/list',
            component: () => import(/* webpackChunkName: "zcfg" */ '../components/ZcfgList'),
        },
        {
            path: '/zcxx/list',
            component: () => import(/* webpackChunkName: "zcfg" */ '../components/ZcfgListNew'),
        },
        {
            path: '/hyjl/home',
            component: () => import(/* webpackChunkName: "zcfg" */ '../components/HyjlHome'),
        },
        {
            path: '/meeting-report/home',
            component: () => import(/* webpackChunkName: "zcfg" */ '../components/MeetingReport'),
        },
        {
            path: '/monthly/home',
            component: () => import(/* webpackChunkName: "zcfg" */ '../components/Monthly'),
        },
        {
            path: '/video-center/home',
            component: () => import(/* webpackChunkName: "zcfg" */ '../components/VideoCenter'),
        },
        {
            path: '/ztbxx/home',
            component: () => import(/* webpackChunkName: "zcfg" */ '../components/Ztbxx'),
        },
        {
            path: '/industry-chat/home',
            component: () => import(/* webpackChunkName: "zcfg" */ '../components/IndustryChat'),
        },
        {
            path: '/report',
            redirect: '/report/list',
        },
        {
            path: '/report/list',
            component: () => import(/* webpackChunkName: "report" */ '../components/ReportList'),
        },
        {
            path: '/report/ufilist',
            component: () => import(/* webpackChunkName: "report" */ '../components/UFIReportList'),
        },
        {
            path: '/report/speciallist',
            component: () => import(/* webpackChunkName: "report" */ '../components/SpecialReportList'),
        },
        {
            path: '/mof/list',
            component: () => import(/* webpackChunkName: "mof" */ '../components/MofList'),
        },
        {
            path: '/zhuanti/home',
            component: () => import(/* webpackChunkName: "mof" */ '../components/zhuanti/ZhuantiHome'),
        },
        {
            path: '/vannaai/home',
            component: () => import(/* webpackChunkName: "mof" */ '../components/VannaAiHome'),
        },
        {
            path: '/macro-economy',
            redirect: '/macro-economy/home',
        },
        {
            path: '/macro-economy/home',
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/MacroEconomy'),
        },
        {
            path: '/jlzc',
            redirect: '/jlzc/all/home',
        },
        {
            path: '/jlzc/home',
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/JlzcHome'),
        },
        {
            path: '/jlzc/all/home',
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/JlzcAllHome'),
        },
        {
            path: '/jlzc/dxzlzx',
            redirect: '/jlzc/dxzlzx/home',
        },
        {
            path: '/jlzc/dxzlzx/home',
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/DxzlzxHome'),
        },
        {
            path: '/jlzc/dxzlzxJd',
            redirect: '/jlzc/dxzlzxJd/home',
        },
        {
            path: '/jlzc/dxzlzxJd/home',
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/DxzlzxJdHome'),
        },
        {
            path: '/jlzc/all/home',
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/JlzcAllHome'),
        },
        {
            path: '/jlzc/ljbl',
            redirect: '/jlzc/ljbl/home',
        },
        {
            path: '/jlzc/ljbl/home',
            //component: () => import(/* webpackChunkName: "macro-economy" */ '../components/LjblHome'),
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/LjblList'),
        },
        {
            path: '/jlzc/hdsblv/home',
            //component: () => import(/* webpackChunkName: "macro-economy" */ '../components/LjblHome'),
            //component: () => import(/* webpackChunkName: "macro-economy" */ '../components/Hdsblc'),
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/HdsblcNew'),
        },
        {
            path: '/jlzc/denglv',
            redirect: '/jlzc/denglv/home',
        },
        {
            path: '/jlzc/denglv/home',
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/DenglvHome'),
        },
        {
            path: '/hysyd/home',
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/Hysyd'),
        },
        {
            path: '/fatj/home',
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/FatjHome'),
        },
        {
            path: '/macro-economy/news',
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/TjjNewsList'),
        },
        {
            path: '/one-stop-service',
            redirect: '/one-stop-service/home',
        },
        {
            path: '/one-stop-service/home',
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/OneStopServiceHome'),
        },
        {
            path: '/zhanhui/details-d',
            component: () => import(/* webpackChunkName: "zcfg" */ '../components/ZhanhuiD'),
        },
        {
            path: '/changguan/details-d',
            component: () => import(/* webpackChunkName: "zcfg" */ '../components/ChangGuanD'),
        },
        {
            path: '/service/details-d',
            component: () => import(/* webpackChunkName: "zcfg" */ '../components/ServiceDetails'),
        },
        {
            path: '/shoping',
            redirect: '/shoping/home',
        },
        {
            path: '/shoping/home',
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/ShopingHome'),
        },
        {
            path: '/points-mall',
            redirect: '/points-mall/home',
        },
        {
            path: '/points-mall/home',
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/PointsMalle'),
        },
        {
            path: '/beijing-gift',
            redirect: '/beijing-gift/home',
        },
        {
            path: '/beijing-gift/home',
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/BeijingGiftHome'),
        },
        {
            path: '/hot-rank',
            redirect: '/hot-rank/home',
        },
        {
            path: '/hot-rank/home',
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/HotRankHome'),
        },
        {
            path: '/event',
            redirect: '/event/home',
        },
        {
            path: '/event/home',
            component: () => import(/* webpackChunkName: "macro-economy" */ '../components/EventHome'),
        },
        {
            path: '/demo/pie-chart',
            component: () => import(/* webpackChunkName: "demo" */ '../components/demo/PieChart'),
        },
        {
            path: '/demo/bar-chart',
            component: () => import(/* webpackChunkName: "demo" */ '../components/demo/BarChart'),
        },
        {
            path: '/demo/map-chart',
            component: () => import(/* webpackChunkName: "demo" */ '../components/demo/MapChart'),
        },
        {
            path: '/demo/province-map-chart',
            component: () => import(/* webpackChunkName: "demo" */ '../components/demo/ProvinceMapChart'),
        },
        {
            path: '/demo/map',
            component: () => import(/* webpackChunkName: "demo" */ '../components/demo/MapContainer'),
        },
        {
            path: '*',
            component: () => import('../components/NotFound')
        }
    ]
})
export default router
